export default __webpack_public_path__ + "static/media/click3.f3c6cd9a.aac";